import { BackendRoute } from '../../config/index';
import { QueryKey } from '../../constants/index';
import { ApiService } from '../../services/index';
import { accessTokenStorage } from '../../storage/auth/index';
import { useAppMutation } from '../use-app-mutation.hook';

interface RegisterDto {
  fullName: string;
  password: string;
  repeatPassword: string;
}

export const useCreateUser = () => {
  const { mutate: create, isPending } = useAppMutation([QueryKey.REGISTER_VERIFY], {
    mutationFn: async ({ data, verificationId }: { data: RegisterDto; verificationId: string }) => {
      const { accessToken } = await ApiService.post<{ accessToken: string }>(
        { endpoint: BackendRoute.AUTH_REGISTER },
        {
          body: { verificationId, ...data, fullName: data.fullName.trim() },
        },
      );
      accessTokenStorage.getState().set(accessToken || '');
    },
  });
  return { create, isPending };
};
